customElements.get("notification-card") || customElements.define("notification-card", class extends HTMLElement {
  constructor() {
    super(), this.inputEl = this.querySelector('input[type="checkbox"][id="notification-card"]'), 
    this.popupDelay = 1e3 * (parseInt(this.dataset.popupDelay) || 2);
  }
  connectedCallback() {
    this.inputEl && (this.inputEl.addEventListener("change", t => {
      requestAnimationFrame(() => {
        this.style.display = "none", this.offsetHeight, this.style.display = "";
      }), window.dispatchEvent(new CustomEvent("notification_card_change", {
        detail: {
          checked: this.inputEl.checked
        }
      })), sessionStorage.setItem("notification-card-dismissed", !this.inputEl.checked);
    }), "true" === sessionStorage.getItem("notification-card-dismissed") || this.inputEl.checked || this.handleSessionBasedDelay());
  }
  handleSessionBasedDelay() {
    const t = Date.now();
    let e = sessionStorage.getItem("session-start-time");
    e ? e = parseInt(e) : (e = t, sessionStorage.setItem("session-start-time", e));
    const s = t - e, i = Math.max(0, this.popupDelay - s);
    setTimeout(() => {
      this.inputEl.click();
    }, i);
  }
  disconnectedCallback() {
    this.inputEl && this.inputEl.removeEventListener("change", this.handleChange);
  }
});